module.exports = __webpack_public_path__ + "img/icon14.7cd538df.png";